import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { UpdateEmailRequest } from '@timechef/core/api';
import { AuthRepository, AuthService } from '@timechef/core/auth';
import { AppErrorKeys } from '@timechef/core/errors/error';
import { I18nService } from '@timechef/core/i18n/i18n.service';
import { TcValidators } from '@timechef/core/utils';
import { AppRequestStatus } from '@timechef/core/utils/elf-utils';
import { EnforceFormGroupType } from '@timechef/core/utils/form-utils';

@Component({
  selector: 'app-account-email-modal',
  templateUrl: './account-email-modal.component.html',
  styleUrls: ['./account-email-modal.component.scss'],
  standalone: false,
})
export class AccountEmailModalComponent implements OnInit {
  @Input() updateHasChanges?: (value: boolean) => void;
  AppErrorKeys = AppErrorKeys;

  emailCtrl = this.fb.nonNullable.control<string>('', { validators: [Validators.required, TcValidators.email] });
  passwordCtrl = this.fb.nonNullable.control<string>('', { validators: Validators.required });
  form: EnforceFormGroupType<UpdateEmailRequest> = this.fb.nonNullable.group({
    email: this.emailCtrl,
    password: this.passwordCtrl,
  });

  requestStatus: AppRequestStatus = { value: 'idle' };

  private authService: AuthService;
  private authRepository: AuthRepository;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    injector: Injector,
    private alertCtrl: AlertController,
    private i18n: I18nService,
  ) {
    this.authService = injector.get(AuthService);
    this.authRepository = injector.get(AuthRepository);
  }

  ngOnInit() {
    this.authRepository.updateAccountEmailRequestStatus$.subscribe((status) => {
      this.requestStatus = status;
    });

    if (this.updateHasChanges) this.form.valueChanges.subscribe((_value) => this.updateHasChanges!(this.form!.dirty));
  }

  async dismissModal() {
    this.authRepository.resetUpdateAccountEmailStatus();
    this.modalCtrl.dismiss();
  }

  onSubmit() {
    if (this.form.invalid || this.requestStatus.value === 'pending') return;

    this.authService.updateAccountEmail(this.form.getRawValue()).subscribe(async (_tokenResult) => {
      this.form?.markAsPristine();
      if (this.updateHasChanges) this.updateHasChanges(false);

      const alert = await this.alertCtrl.create({
        message: this.i18n.translate('ACCOUNT_EMAIL_MODAL_COMPONENT.SUCCESS'),
        buttons: [this.i18n.translate('ACCOUNT_EMAIL_MODAL_COMPONENT.OK')],
      });
      await alert.present();
      if (await alert.onWillDismiss()) {
        this.modalCtrl.dismiss();
      }
    });
  }
}
